import React, { useContext, useMemo, useState } from 'react';

import PageLoader from '../components/common/PageLoader';
import StickyPageHeader from '../components/common/StickyPageHeader';
import ClassList from '../components/lists/ClassList';
import { AuthContext } from '../contexts/authContext';
import {
  useClassVehicleMap,
  useDefaultVehicles,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierRateClassesPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const { defaultVehicles, status: defaultVehiclesStatus } = useDefaultVehicles();
  const { classVehicleMap, status: classVehicleMapStatus } = useClassVehicleMap();
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierVehicles = useMemo(
    () => [...defaultVehicles, ...(selectedCarrier?.vehicles || [])],
    [defaultVehicles, selectedCarrier?.vehicles]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'classPermission');

  const pageDataLoading =
    defaultVehiclesStatus === 'loading' || classVehicleMapStatus === 'loading';

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Rate Classes"
        />
        <ClassList
          carrier={selectedCarrier}
          classVehicleMap={classVehicleMap}
          id="rate-class"
          userRole={authUser?.role}
          vehicles={carrierVehicles}
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return pageDataLoading ? <PageLoader /> : (content || null);
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier || pageDataLoading}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierRateClassesPage;
